/**
 * ModuleItemProperty enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file ModuleItemProperty.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum ModuleItemProperty {
  Ability = 0,
  Armor = 1,
  ArmorAlignmentGroup = 2,
  ArmorDamageType = 3,
  ArmorRacialGroup = 4,
  AttackBonus = 38,
  AttackBonusAlignmentGroup = 39,
  AttackBonusRacialGroup = 40,
  AttackPenalty = 8,
  Blaster_Bolt_Defect_Decrease = 56,
  Blaster_Bolt_Deflect_Increase = 55,
  BonusFeats = 9,
  CastSpell = 10,
  Computer_Spike = 53,
  Damage = 11,
  DamageAlignmentGroup = 12,
  DamageImmunity = 14,
  DamageMelee = 22,
  DamageNone = 31,
  DamagePenalty = 15,
  DamageRacialGroup = 13,
  DamageRanged = 23,
  DamageReduced = 16,
  DamageResist = 17,
  Damage_Vulnerability = 18,
  DecreaseAC = 20,
  DecreaseAbilityScore = 19,
  DecreasedSkill = 21,
  Disguise = 59,
  Droid_Repair_Kit = 58,
  Enhancement = 5,
  EnhancementAlignmentGroup = 6,
  EnhancementRacialGroup = 7,
  Freedom_of_Movement = 50,
  Immunity = 24,
  ImprovedMagicResist = 25,
  ImprovedSavingThrows = 26,
  ImprovedSavingThrowsSpecific = 27,
  Keen = 28,
  Light = 29,
  Massive_Criticals = 49,
  Mighty = 30,
  Monster_Damage = 51,
  OnHit = 32,
  OnMonsterHit = 48,
  ReducedSavingThrows = 33,
  ReducedSpecificSavingThrow = 34,
  Regeneration = 35,
  Regeneration_Force_Points = 54,
  Skill = 36,
  Special_Walk = 52,
  ThievesTools = 37,
  ToHitPenalty = 41,
  Trap = 46,
  True_Seeing = 47,
  UnlimitedAmmo = 42,
  UseLimitationAlignmentGroup = 43,
  UseLimitationClass = 44,
  UseLimitationRacial = 45,
  Use_Limitation_Feat = 57,
};